import type { ButtonConfig } from '../../declare'
import { EasyModal, EasyIcon } from 'src/components'
import { PrintTemplate } from 'src/components/root/components/common'

type Props = {
  config: ButtonConfig
}

const PrintBtn = (props: Props) => {
  const { __RECORD__: record, __RENDER_SLOT__: renderSlot, LABEL, ICON, FORM_CODE, WORD_TEMPLATE_CODE } = props.config
  return (
    <EasyModal
      fullModal
      modal={{
        title: record?.NAME || record?.ALIAS || FORM_CODE,
        width: '100%',
        styles: { body: { overflow: 'hidden' } }
      }}
      slot={
        renderSlot?.(props.config) ?? (
          <span>
            <EasyIcon type={ICON} defaultIcon='PrinterOutlined' className='fz-16' />
            <span title={LABEL} className='pd-l4'>{LABEL}</span>
          </span>
        )
      }
    >
      <PrintTemplate code={WORD_TEMPLATE_CODE} />
    </EasyModal>
  )
}

export default PrintBtn